import { Box, Skeleton } from "@mui/material";
import { BRAND_STAGES } from "./brandStagesApiMapping";

const PLACEHOLDER_COLUMNS = 5;
const GRID_TEMPLATE = `150px repeat(${PLACEHOLDER_COLUMNS}, minmax(0, 1fr))`;

export default function BrandStagesMatrixSkeleton() {
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Box sx={{ minWidth: 1000 }}>
        <Box sx={{ display: "grid", gridTemplateColumns: GRID_TEMPLATE }}>
          <Box sx={{ p: "8px 10px 12px", borderBottom: "1px solid #ececec" }}>
            <Skeleton variant="text" width={50} />
          </Box>
          {Array.from({ length: PLACEHOLDER_COLUMNS }, (_, column) => (
            <Box key={column} sx={{ p: "8px 12px 12px", borderBottom: "1px solid #ececec", borderLeft: "1px solid #f4f4f4" }}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="50%" />
            </Box>
          ))}
        </Box>
        {BRAND_STAGES.map((stage, row) => (
          <Box key={stage.step} sx={{ display: "grid", gridTemplateColumns: GRID_TEMPLATE }}>
            <Box sx={{ p: "14px 10px", borderBottom: "1px solid #f4f4f4" }}>
              <Skeleton variant="text" width={90} />
            </Box>
            {Array.from({ length: PLACEHOLDER_COLUMNS }, (_, column) => (
              <Box
                key={column}
                sx={{ p: "11px 12px", borderLeft: "1px solid #f4f4f4", borderBottom: "1px solid #f4f4f4" }}
              >
                <Skeleton variant="rounded" height={22} sx={{ width: `${62 - row * 10}%`, borderRadius: "4px" }} />
                <Skeleton variant="text" width={60} sx={{ mt: 0.5 }} />
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
